import { Button, Heading, Link, Section } from 'components'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'

const IntegrationArchive = ({ data }) => {
  const { nodes } = data.content
  const categories = {
    all: 'All',
  }
  nodes.forEach((node) => {
    node.categories.nodes.forEach((node) => {
      categories[node.id] = node.name
    })
  })

  return (
    <>
      <Section>
        <div className="max-w-4xl space-y-5 mx-auto text-center">
          <Heading>Integrations, Plugins & Connectors</Heading>
          <p className="text-xl leading-loose">
            Our goal is to work with your existing technology stack (the tools
            you already use). Our role is to push the data and insights to where
            they need to go.
          </p>
          <p className="leading-loose">
            We have developed native integrations with many tools and are
            constantly adding new ones. We also support all major email
            marketing automation tools for newsletter and email tracking and
            identification. Contact us for a demo or to learn what other options
            we have available.
          </p>
        </div>
      </Section>
      <Section>
        <div className="flex justify-center gap-4">
          {Object.values(categories).map((category) => {
            return (
              <div className="px-4 py-2 bg-transparent border broder-gray-200 text-primary-500 uppercase text-xs tracking-wide">
                {category}
              </div>
            )
          })}
        </div>

        <div className="grid grid-cols-4 gap-16 mt-16">
          {nodes.map(
            ({ title, id, content, slug, featuredImage, categories }) => (
              <div key={id} className="text-center">
                {featuredImage && (
                  <Link to={`/integrations/${slug}`}>
                    <div className="w-16 mx-auto">
                      <Img
                        fluid={
                          featuredImage.node.localFile.childImageSharp.fluid
                        }
                      />
                    </div>
                  </Link>
                )}
                <Heading level="6" className="p-0 mt-4 text-sm">
                  <Link to={`/integrations/${slug}`}>{title}</Link>
                </Heading>
                <div className="flex justify-center flex-wrap gap-1">
                  {categories.nodes.map((category) => (
                    <div className="text-xs uppercase bg-gray-50 border border-gray-200 px-2 rounded py-1">
                      {category.name}
                    </div>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </Section>
      <Section background="bg-gray-100" className="text-center">
        <div className="max-w-3xl mx-auto">
          <Heading level="3">
            Don’t miss the chance to connect with visitors and automatically
            identify new leads.
          </Heading>
          <Button type="primary" to="/demo">
            Schedule a Demo
          </Button>
        </div>
      </Section>
    </>
  )
}

export const query = graphql`
  query GET_INTEGRATIONS($skip: Int!) {
    content: allWpIntegration(
      sort: { order: DESC, fields: date }
      limit: 30
      skip: $skip
    ) {
      nodes {
        id
        slug
        title
        content
        date(formatString: "MMMM DD, YYYY")
        featuredImage {
          node {
            localFile {
              childImageSharp {
                id
                fluid(maxWidth: 200, maxHeight: 200) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
        categories {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`

export default IntegrationArchive
